import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { IReportShowAllCheckbox } from "./ReportShowAllCheckboxInterfaces";
import { useStyles } from "./ReportShowAllCheckbox.styles";
import { useTranslation } from "react-i18next";

const ReportShowAllCheckbox = ({ onChange, checked }: IReportShowAllCheckbox) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <FormGroup>
            <FormControlLabel
                className={classes.checkboxLabel}
                control={<Checkbox color="info" checked={checked} onChange={onChange} size="small" />}
                label={t("report_show_all_checkbox.show_all")}
            />
        </FormGroup>
    );
};

export default ReportShowAllCheckbox;
